// @NOTE: assumes jQuery is included by WP
const $ = jQuery

import { header } from './header'
import { modules } from './modules';
import { news } from './news'
import { search } from './search'

const $window = $(window)

class Custom {

  init () {
    this.Header            = new header()
    this.Modules           = new modules()
    this.News              = new news()
    this.Search            = new search()
  }

  onWindowResize (windowWidth) {
    // all methods that respond to window resize should be here
    this.Header.onWindowResize(windowWidth)
  }

  onWindowScroll (scrollTop) {
    // all methods that respond to window scroll should be here
    // this.Header.onWindowScroll(scrollTop)
  }

  onWindowLoad () {

  }

  onPageShow () {
    // this.Header.onPageShow()
  }
}

const custom  = new Custom()

var resizeThreshold;
$window.resize(() => {
  clearTimeout(resizeThreshold);
  resizeThreshold = setTimeout(function() {
    custom.onWindowResize($window.width())
  }, 100);
});

$window.scroll(() => {
  custom.onWindowScroll(window.scrollY)
})

$(document).ready(() => {
  custom.onWindowResize($window.width())
})

window.onload = () => {
  custom.onWindowLoad()
}

window.onpageshow = (event) => {
  if (event.persisted) {
    custom.onPageShow()
    // window.location.reload();
  }
}

export default custom